import React from 'react';
import Icon from './Icon';

export default Icon(
  <g>
    <g>
      <polyline points="3,0 9,6 3,12 3,12" />
    </g>
  </g>, '0 0 12 12', 'SortRightIcon',
);
